import React from 'react'
import ReactDOM from 'react-dom'

class ContextMenuPortal extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    
    render() {
        
        const el = document.querySelector("#contextMenu");

        if (el)
            return ReactDOM.createPortal(this.props.children, el);
        else
            return null;
    }

}


export default ContextMenuPortal;